/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  ICurveMetaPoolFactoryLike,
  ICurveMetaPoolFactoryLikeInterface,
} from "../ICurveMetaPoolFactoryLike";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_pool",
        type: "address",
      },
    ],
    name: "get_coins",
    outputs: [
      {
        internalType: "address[4]",
        name: "",
        type: "address[4]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_pool",
        type: "address",
      },
    ],
    name: "is_meta",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class ICurveMetaPoolFactoryLike__factory {
  static readonly abi = _abi;
  static createInterface(): ICurveMetaPoolFactoryLikeInterface {
    return new utils.Interface(_abi) as ICurveMetaPoolFactoryLikeInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ICurveMetaPoolFactoryLike {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as ICurveMetaPoolFactoryLike;
  }
}
